// styled components
import {
    Link,
    SingleLink,
    StyledAccordion,
    StyledAccordionDetails,
    StyledAccordionSummary,
    StyledDrawer
}
    from './styles';

// components
import Logo from '@components/Logo';
import { NavLink, useLocation } from 'react-router-dom';

// hooks
import { useSidebar } from '@contexts/sidebarContext';
import { useWindowSize } from 'react-use';
import { useEffect, useState } from 'react';
import { useAuth } from '@contexts/authContext';


const Sidebar = () => {
    const { links } = useAuth();

    const { open, setOpen } = useSidebar();

    const [expanded, setExpanded] = useState(undefined);
    const { pathname } = useLocation();
    const { width } = useWindowSize();

    // manually handle accordion expansion
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    }

    // collapse opened accordion on route change when the drawer is temporary
    useEffect(() => {
        width < 1280 && setExpanded(undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return (
        <StyledDrawer
            variant={width < 1920 ? 'temporary' : 'permanent'}
            anchor="left"
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            sx={{
                '& .MuiDrawer-paper': {
                    width: 250,
                }
            }}
            className="main-sidebar">
            <div className="logo-wrapper">
                <Logo size="sm" />
            </div>
            <SingleLink className={pathname === '/' ? 'pinned active' : 'pinned'} as="div">
                <NavLink to="/">
                    <Link className={`${pathname === '/' ? 'active' : ''} h4`}>
                        <i className="icon icon-home" /> Inicio
                    </Link>
                </NavLink>
            </SingleLink>

            <nav className="d-flex flex-column g-8 flex-1">
                {
                    links.map((link, index) => (
                        <StyledAccordion key={link.title}
                            expanded={expanded === `panel${index}`}
                            onChange={handleChange(`panel${index}`)}>
                            <StyledAccordionSummary>
                                <Link className={`${expanded === `panel${index}` ? 'active' : ''} h4`}>
                                    <i className={`icon icon-${link.icon}`} /> {link.title}
                                </Link>
                                <i className="icon icon-chevron-down" />
                            </StyledAccordionSummary>
                            <StyledAccordionDetails>
                                {
                                    link.pages.map(page => (
                                        <NavLink to={page.path} key={page.title}>
                                            {page.title}
                                        </NavLink>
                                    ))
                                }
                            </StyledAccordionDetails>
                        </StyledAccordion>
                    ))
                }
            </nav>
            <SingleLink className={pathname === '/statics' ? 'pinned active' : 'pinned'} as="div">
                <NavLink to="/statistics2024">
                    <Link className={`${pathname === '/statistics2024' ? 'active' : ''} h4`}>
                        <i className="icon icon-table" /> Estadísticas 2026-1
                    </Link>
                </NavLink>
            </SingleLink>
            <SingleLink className={pathname === '/statics' ? 'pinned active' : 'pinned'} as="div">
                <NavLink to="/schedule">
                    <Link className={`${pathname === '/schedule' ? 'active' : ''} h4`}>
                        <i className="icon icon-calendar" /> Calendario
                    </Link>
                </NavLink>
            </SingleLink>
            <SingleLink className={pathname === '/teams' ? 'pinned active' : 'pinned'} as="div">
                <NavLink to="/teams">
                    <Link className={`${pathname === '/teams' ? 'active' : ''} h4`}>
                        <i className="icon icon-users" /> Equipos
                    </Link>
                </NavLink>
            </SingleLink>
            <SingleLink className={pathname === '/dian' ? 'pinned active' : 'pinned'} as="div">
                <NavLink to="/dian">
                    <Link className={`${pathname === '/dian' ? 'active' : ''} h4`}>
                        <i className="icon icon-pdf" /> Documentos DIAN
                    </Link>
                </NavLink>
            </SingleLink>
        </StyledDrawer>
    );
}

export default Sidebar